<section
  class="border-b fixed top-0 z-50 w-full bg-white-color border-gray-color"
>
  <div
    class="container mx-auto flex items-center justify-between h-[70px] relative"
  >
    <!-- Logo -->
    <div class="flex items-center">
      <img
        src="assets/images/ui/logo.png"
        routerLink="/"
        alt="Phlenu Delivery Logo"
        class="cursor-pointer w-[75px] sm:w-[100px] lg:w-[130px] md:py-3 sm:py-2 py-2 md:ml-0 sm:ml-0"
      />
    </div>

    <!-- Wallet & User -->
    <div class="hidden md:flex items-center gap-3 lg:gap-4">
      <div *ngIf="this.isBusinessPartner">
        <img
          draggable="false"
          class="w-24 mr-4"
          src="assets/images/ui/business_partner.png"
          alt=""
        />
      </div>

      <!-- Navigation -->
      <nav class="flex items-center gap-8">
        <a
          routerLink="/"
          routerLinkActive="active-header-link"
          [routerLinkActiveOptions]="{ exact: true }"
          class="text-sm lg:text-base font-semibold text-[#23235F] hover:text-[#FF3000] relative"
        >
          Dashboard
        </a>
        <a
          routerLink="/orders"
          routerLinkActive="active-header-link"
          class="text-sm lg:text-base font-semibold text-[#23235F] hover:text-[#FF3000] transition-colors"
        >
          Order History
        </a>
      </nav>
      <div
        (click)="dialogOpen()"
        class="flex items-center bg-[#F5F6FA] px-4 py-2 rounded-full cursor-pointer gap-2 shadow-sm"
      >
        <img src="assets/images/ui/wallet.png" alt="Wallet" class="w-6" />
        <span class="text-sm lg:text-base font-semibold text-[#23235F]"
          >{{ this.country == "Ghana" ? "GHS" : "NGN" }}
          <span class="text-green-600">{{
            this._auth.walletAmount | async
          }}</span>
        </span>
      </div>

      <div class="flex">
        <div
          class="w-10 h-10 rounded-full overflow-hidden border-2 border-blue-theme-color flex items-center justify-center"
        >
          <ng-container *ngIf="userImage; else noImage">
            <img
              [src]="this._auth.userProfileData.value?.profileImage"
              alt="User"
              class="w-full h-full object-cover"
            />
          </ng-container>

          <ng-template #noImage>
            <mat-icon>person</mat-icon>
          </ng-template>
        </div>
        <button
          mat-icon-button
          [matMenuTriggerFor]="beforeMenu"
          aria-label="Example icon-button with a menu"
        >
          <mat-icon>expand_more</mat-icon>
        </button>
        <mat-menu #beforeMenu="matMenu" xPosition="before">
          <button mat-menu-item>
            <mat-icon>account_circle</mat-icon>
            <span class="capitalize">{{
              this._auth.userProfileData.value?.name
            }}</span>
          </button>

          <button (click)="this.userLogout()" mat-menu-item>
            <mat-icon>logout</mat-icon>
            <span>Logout</span>
          </button>
        </mat-menu>
      </div>

      <!-- <button class="ml-2" (click)="this.userLogout()" mat-icon-button matTooltip="Log-out">
                <mat-icon class="text-[#23235F]">expand_more</mat-icon>
            </button> -->
    </div>
    <div
      class="md:hidden sm:flex flex items-center absolute md:right-0 sm:right-0 right-0 sm:gap-2 gap-1 top-[50%] translate-y-[-50%] pr-4"
    >
      <div *ngIf="this.isBusinessPartner">
        <img
          draggable="false"
          class="w-[22px] aspect-square object-contain mr-1"
          src="assets/images/ui/mobile_bp.png"
          alt=""
        />
      </div>
      <div
        (click)="dialogOpen()"
        class="flex-1 max-h-[40px] cursor-pointer bg-star-gray px-2 py-1 rounded-full flex gap-1 items-center justify-start"
        matRipple
      >
        <div class="flex justify-center items-center flex-col p-1 rounded-md">
          <img
            src="assets/images/ui/wallet.png"
            alt=""
            draggable="false"
            class="w-5"
          />
          <!-- <span class="text-xs text-[#ff3000] font-semibold select-none">Wallet</span> -->
        </div>
        <!-- <img src="assets/images/ui/wallet.png" alt="" draggable="false" class="w-6"> -->
        <span class="text-black-color text-[12px]"
          >{{ this.country == "Ghana" ? "GHS" : "NGN" }}
          <span class="text-green-color">{{
            this._auth.walletAmount | async
          }}</span></span
        >
      </div>

      <div
        class="flex justify-center items-center flex-col rounded-md"
        routerLink="/"
        matRipple
      >
        <!-- <button class="flex !flex-col" matTooltip="Log-out" routerLink="/orders" mat-icon-button> -->
        <img
          src="assets/images/icons/home.png"
          class="w-[20px] aspect-square object-contain"
          alt=""
        />
        <span class="text-[10px] text-[#ff3000] font-medium select-none"
          >Home</span
        >
        <!-- </button> -->
      </div>

      <div
        class="flex justify-center items-center flex-col"
        routerLink="/orders"
        matRipple
      >
        <!-- <button class="flex !flex-col" matTooltip="Log-out" routerLink="/orders" mat-icon-button> -->
        <img
          src="assets/images/ui/orderhistory.png"
          class="w-[20px] aspect-square object-contain"
          alt=""
        />
        <span class="text-[10px] text-[#ff3000] font-medium select-none"
          >Orders</span
        >
        <!-- </button> -->
      </div>
      <div class="flex">
        <div
          class="w-[35px] h-[35px] rounded-full overflow-hidden border-2 border-blue-theme-color flex items-center justify-center"
        >
          <ng-container *ngIf="userImage; else noImage">
            <img
              [src]="userImage"
              alt="User"
              class="w-full h-full object-cover"
            />
          </ng-container>

          <ng-template #noImage>
            <mat-icon>person</mat-icon>
          </ng-template>
        </div>
        <button
          mat-icon-button
          [matMenuTriggerFor]="beforeMenu"
          aria-label="Example icon-button with a menu"
        >
          <mat-icon>expand_more</mat-icon>
        </button>
        <mat-menu #beforeMenu="matMenu" xPosition="before">
          <button mat-menu-item>
            <mat-icon>account_circle</mat-icon>
            <span class="capitalize">{{ userName }}</span>
          </button>

          <button (click)="this.userLogout()" mat-menu-item>
            <mat-icon>logout</mat-icon>
            <span>Logout</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</section>
